import { useMutation, UseMutationResult } from 'react-query';
import { useFetchMutation } from '../../../helpers/api';
import { v4 as uuidv4 } from 'uuid';

type UseCreatePortfolioConstructionByConsultFormArguments = {
  caseId: string;
  milestoneActionId: string;
  successToastMessage: string;
  versionName: string;
};

export function useCreatePortfolioConstructionByConsultForm(): UseMutationResult<
  unknown,
  unknown,
  UseCreatePortfolioConstructionByConsultFormArguments
> {
  const { fetchMutation } = useFetchMutation();
  const UUId = uuidv4();
  return useMutation(
    ({
      caseId,
      milestoneActionId,
      successToastMessage,
      versionName,
    }: UseCreatePortfolioConstructionByConsultFormArguments) =>
      fetchMutation({
        path: `/v2/cases/${caseId}/milestones/actions/${UUId}/portfolioConstruction`,
        method: 'POST',
        body: {
          versionName,
          consultFormId: milestoneActionId,
        },
        invalidateQueries: [['cases'], ['cases', caseId]],
        successToastMessage,
      }),
  );
}
